export default __webpack_public_path__ + "static/media/chrome4-preview.dc555067.png";